import React from 'react';
import { useDispatch } from 'react-redux';
import { useInterval, useSelector } from '../hook-utils';
import { actions } from '../store';
import { selectClientNotifcations } from '../store/reducers/toasts';
import { ReactComponent as CloseIcon } from './icons/close.svg';
import './Toaster.scss';

export default function ClientNotification() {
  const toasts = useSelector(selectClientNotifcations)

  return <div className='Toaster'>
    {Object.entries(toasts).map(([id, text]) => <Toast key={id} id={id} text={text.text} timer={text.timer === undefined ? true : text.timer} closable={text.closable === undefined ? true : text.closable} />)}
  </div>
}

interface Props {
  id: string
  text: string
  closable: boolean
  timer: boolean
}

function Toast({ id, text, closable, timer }: Props) {
  const dispatch = useDispatch()

    useInterval(close, timer ? 5000 : 200000)

  function close() {
    dispatch(actions.closeClientNotification(id))
  }

  return <div className='Toast' onClick={close}>
    <div className='text' dangerouslySetInnerHTML={{ __html: text }} ></div>
    <button>
      {closable && <CloseIcon />}
    </button>
  </div>
}
